import { XANO } from 'drapcode-constant';
import { alertMessagesArgsConfig, browserStorageArgsConfig } from '../../utils/event_constants';

export const xanoActions = [
  {
    name: 'sendDataToExternalSource',
    label: 'Xano: Sign Up',
    type: 'AUTH',
    source: XANO,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsXano',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Xano: Sign In via Email & Password',
    type: 'AUTH',
    source: XANO,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsXano',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Xano: Sign Out',
    type: 'AUTH',
    source: XANO,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsXano',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'authorizeWithExternalDataSource',
    label: 'Xano: Authorize Using API',
    type: 'AUTH',
    source: XANO,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsXano',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Xano: Send Data To API',
    source: XANO,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsXano',
        value: '',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
];
